import { render, staticRenderFns } from "./CreditsReact.vue?vue&type=template&id=f9cd9360&"
import script from "./CreditsReact.vue?vue&type=script&lang=js&"
export * from "./CreditsReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports